<template>
  <div class="small">
    <modals-container
      @importCategories="passImportCategories"
      @updateCategoryName="passUpdateCategoryName"
      @budgetDone="passBudgetDone"
      @confirmCategory="confirmCategory"
      @addCategory="passAddCategory"
      id="delete-row-modal"
      @confirmRemoveDocument="passConfirmRemoveDocument"
    ></modals-container>

    <stacked-bar-chart
      :options="stackedOptions"
      :chartData="stackedChartDataCollection"
      :key="'A' + componentKeyStackedBar"
    ></stacked-bar-chart>

    <!-- <horizontal-bar-chart :options="horizontalBarChartOptions" v-if="horizontalBarDataCollection"
                              :chart-data="horizontalBarDataCollection"></horizontal-bar-chart> -->
    <mixed-chart
      :chartData="mixedChartDataCollection"
      v-if="mixedChartDataCollection"
      :options="mixedChartOptions"
      :key="'B' + componentKeyMixedChart"
    ></mixed-chart>
    <div class="col-md-10" style="margin-top: 25px">
      <div style="display: flex">
        <div class="col-md-6">
          <label style="height: 35px; font-size: 15px" for="">{{
            $t("message.distributionActuals")
          }}</label>
          <hr />
          <doughnut-chart
            :options="doughnutOptions"
            :chartData="doughnutDataActuals"
            class="doughnut"
          ></doughnut-chart>
        </div>

        <div class="col-md-6">
          <label style="height: 35px; font-size: 15px" for="">{{
            $t("message.distributionBudget")
          }}</label>
          <hr />
          <doughnut-chart
            :options="doughnutOptions"
            :chartData="doughnutDataBudget"
            class="doughnut"
          ></doughnut-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import HorizontalBarChart from '../../charts/HorizontalBarChart'
import MixedChart from "../../charts/MixedChart";
import StackedBarChart from "../../charts/StackedBarChart";
import DoughnutChart from "../../charts/DoughnutChart";

//import BarChart           from '../../charts/BarChart'

export default {
  components: {
    // HorizontalBarChart,
    MixedChart,
    StackedBarChart,
    DoughnutChart,
    // BarChart
  },
  data() {
    return {
      componentKeyStackedBar: 0,
      componentKeyMixedChart: 0,
      doughnutDataActuals: {},
      doughnutDataBudget: {},
      barComparision: null,
      barActualCostsData: null,
      barDynamicBudget: null,
      horizontalBarDataCollection: null,
      mixedDates: [],
      mixedRollingForecastCosts: [],
      mixedTotalBudgetHistory: [],
      stackedChartDataCollection: null,
      mixedChartDataCollection: null,
      doughnutOptions: {
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              return this.formatToolTipsDoughnutCharts(tooltipItem, data);
            },
          },
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      stackedOptions: {
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              return this.formatToolTipsHorizontalBars(tooltipItem, data);
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
            },
          ],
        },
      },
      chartOptions: {
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let value =
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return value
                .toFixed(2)
                .toString()
                .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1’");
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            // This more specific font property overrides the global property
            fontColor: "black",
            defaultFontStyle: "bold",
            defaultFontSize: 14,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value) {
                  return value
                    .toString()
                    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1’");
                },
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      mixedChartOptions: {
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              return this.formatToolTipsHorizontalBars(tooltipItem, data);
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                padding: 25,
                callback: function (value) {
                  return value
                    .toString()
                    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1’");
                },
              },
            },
          ],
          xAxes: [
            {
              //  barThickness: 25,  // number (pixels) or 'flex'
              //  maxBarThickness: 30 // number (pixels)
            },
          ],
        },
      },
      horizontalBarChartOptions: {
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let value =
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return value
                .toFixed(2)
                .toString()
                .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1’");
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            // This more specific font property overrides the global property
            fontColor: "black",
            defaultFontStyle: "bold",
            defaultFontSize: 14,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value) {
                  return value
                    .toString()
                    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1’");
                },
              },
            },
          ],
        },
      },
      actual: null,
      budget: null,
    };
  },
  created() {
    this.get(
      this.apiPrefix,
      `${this.sheetApiUrl}costs-per-sheet/`,
      this.$route.params["id"]
    )
      .then((resp) => {
        if (
          resp.data.targetCost !== 0 ||
          resp.data.staticBudget !== 0 ||
          resp.data.rollingForecast !== 0 ||
          resp.data.actualCosts !== null ||
          resp.data.dynamicBudget !== null ||
          resp.data.additionalBudget
        ) {
          this.stackedChartDataCollection = this.parseDataForStackedChart(
            resp.data
          );
          this.componentKeyStackedBar++;
          this.horizontalBarDataCollection = this.parseDataForChartTotal(
            resp.data,
            "#f87979",
            this.$t("message.costs")
          );
        }
      })
      .catch((err) => {
        console.log(err.response);
      });

    this.get(
      this.apiPrefix,
      `${this.sheetApiUrl}rolling-forecast-budget-history/`,
      this.$route.params["id"]
    )
      .then((resp) => {
        // consolidate data and assign them to global variables

        if (
          resp.data.budget_history.dates.length !== 0 ||
          resp.data.rolling_forecast.dates.length !== 0
        ) {
          let completeData = this.consolidateData(resp);

          let backgroundColorsBars = this.getVerticalBarColors(
            resp.data.budget_history.dates
          );

          // corner case when only actual costs for current month exist
          let date = new Date();
          let firstDay = this.$moment(
            new Date(date.getFullYear(), date.getMonth(), 1)
          ).format("YYYY-MM-DD");
          if (
            resp.data.budget_history.dates.length == 1 &&
            resp.data.budget_history.dates[0] == firstDay
          ) {
            completeData.mixedDates = resp.data.budget_history.dates;
            completeData.mixedTotalBudgetHistory =
              resp.data.budget_history.total_budget;
          }

          this.mixedChartDataCollection = this.parseDataForMixedChartTotal(
            completeData.mixedRollingForecastCosts,
            completeData.mixedTotalBudgetHistory,
            this.$t("message.rollingForecast"),
            this.$t("message.budgetHistory"),
            completeData.mixedDates,
            backgroundColorsBars
          );

          // component needs to be recreated after the data is loaded from the server
          this.componentKeyMixedChart++;
        }
      })
      .catch((err) => {
        console.log(err.response);
      });

    this.getList(
      this.apiPrefix,
      this.costsBudgetApiUrl,
      `?sheet_id=${this.$route.params["id"]}`
    )
      .then((resp) => {
        if (resp.data.length) {
          let actualCostsGroup = this.groupTotalsPerDate(
            resp.data
              .filter((obj) => {
                return obj.is_actual;
              })
              .map((obj) => {
                return {
                  total: obj.total,
                  date: obj.date,
                };
              })
          );

          this.barActualCostsData = this.parseDataForChartTotal(
            actualCostsGroup,
            "#0b93d5",
            this.$t("message.actualCosts")
          );

          let budgetGroup = this.groupTotalsPerDate(
            resp.data
              .filter((obj) => {
                return !obj.is_actual;
              })
              .map((obj) => {
                return {
                  total: obj.total,
                  date: obj.date,
                };
              })
          );

          this.barDynamicBudget = this.parseDataForChartTotal(
            budgetGroup,
            "#0b93d5",
            this.$t("message.dynamicBudget")
          );

          const comparisionData = this.getAllDatesForComparison(
            actualCostsGroup,
            budgetGroup
          );
          this.barComparision = this.parseDataForComparision(
            comparisionData,
            this.$t("message.actualCosts"),
            this.$t("message.dynamicBudget"),
            "#0b93d5",
            "#f87979"
          );
        }
      })
      .catch((err) => {
        console.log(err.response);
      });

    this.getPieChartData();
  },
  methods: {
    formatToolTipsDoughnutCharts(tooltipItem, data) {
      let value =
        data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
      let label = data.labels[tooltipItem.index];

      if (value !== null)
        return `${label}, CHF ${value
          .toFixed(0)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, "`")}`;
      return "CHF 0";
    },
    getPieChartData() {
      this.get(
        this.apiPrefix,
        this.costsBudgetApiUrl + "piecharts-per-cost-type-sheet/",
        this.$route.params.id
      )
        .then((resp) => {
          let actualData = resp.data["actual"];
          let budgetData = resp.data["budget"];

          this.doughnutDataActuals = {
            labels: this.setPieChartLabels(actualData),
            datasets: [
              {
                borderWidth: 1,
                borderColor: this.setPieChartColors(actualData),
                backgroundColor: this.setPieChartColors(actualData),
                data: this.setPieChartValues(actualData),
              },
            ],
          };

          this.doughnutDataBudget = {
            labels: this.setPieChartLabels(budgetData),
            datasets: [
              {
                borderWidth: 1,
                borderColor: this.setPieChartColors(budgetData),
                backgroundColor: this.setPieChartColors(budgetData),
                data: this.setPieChartValues(budgetData),
              },
            ],
          };
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    setPieChartColors(data){
       let colors = []

       for (let i = 0; i < data.length; i++) {
        if (data[i][0] === "additional costs") {
          colors.push("#ee4035");
        } else if (data[i][0] === "foreign power") {
          colors.push("#f37736");
        } else if (data[i][0] === "inventory") {
          colors.push("#fdf498");
        } else if (data[i][0] === "material") {
          colors.push("#2e003e");
        } else {
          colors.push("#0392cf");
        }
      }

      return colors
    },
    setPieChartValues(data) {
      let values = [];

      for (let i = 0; i < data.length; i++) {
        values.push(data[i][1]);
      }

      return values;
    },
    // method for setting type of costs in pie chart labels
    setPieChartLabels(data) {
      let labels = [];

      for (let i = 0; i < data.length; i++) {
        if (data[i][0] === "additional costs") {
          labels.push(this.$t("message.additionalCosts"));
        } else if (data[i][0] === "foreign power") {
          labels.push(this.$t("message.foreignService"));
        } else if (data[i][0] === "inventory") {
          labels.push(this.$t("message.inventory"));
        } else if (data[i][0] === "material") {
          labels.push(this.$t("message.material"));
        } else {
          labels.push(this.$t("message.personnel"));
        }
      }

      return labels;
    },
    // generalMixin method for returning the array of correct colors for vertical bars rolling forecast
    getVerticalBarColors(dates) {
      return this.getBarColors(dates);
    },
    parseDataForMixedChartTotal(
      rollingForecast,
      budgetTotal,
      labelLine,
      labelBars,
      labels,
      backgroundColorsBars
    ) {
      return {
        labels: labels,
        datasets: [
          {
            // one line graph
            label: labelLine,
            type: "line",
            data: rollingForecast,
            backgroundColor: "rgba(93,184,100,.5)",
          },
          {
            // bar graph
            label: labelBars,
            type: "bar",
            barThickness: 25,
            data: budgetTotal,
            backgroundColor: backgroundColorsBars,
          },
        ],
      };
    },
    // method for creating consolidated data from rolling forecast and budgets
    consolidateData(resp) {
      return this.consolidate(resp);
    },
    parseDataForStackedChart(data) {
      const chartData = {
        labels: [
          this.$t("message.targetCost"),
          this.$t("message.staticBudget"),
          this.$t("message.actualCosts"),
       //   this.$t("message.dynamicBudget"),
          this.$t("message.rollingForecast"),
        ],
        datasets: [
          {
            barThickness: 17,
            label: this.$t("message.data"),
            backgroundColor: "rgba(236, 72, 78, 0.5)",
            hoverBackgroundColor: "rgba(236, 72, 78, 1)",
            data: [
              data.targetCost,
              data.staticBudget,
              data.actualCosts,
            //  data.dynamicBudget,
              data.rollingForecast,
            ],
          },
          {
            barThickness: 17,
            label: this.$t("message.additionalBudget"),
            backgroundColor: "rgba(74, 167, 222, 0.5)",
            hoverBackgroundColor: "rgba(74, 167, 222, 1)",
            data: [
              0,
              data.additionalBudget,
              0,
              data.additionalBudget,
              data.additionalBudget,
            ],
          },
        ],
      };

      return chartData;
    },
    parseDataForChartTotal(data, color, label) {
      const chartData = {
        labels: [],
        datasets: [
          {
            barThickness: 12,
            label: label,
            backgroundColor: color,
            data: [],
          },
        ],
      };

      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          this.parseDataForChartSingle(key, data, chartData);
        }
      }
      return chartData;
    },
    parseDataForChartSingle(key, data, chartObj) {
      if (key.charAt(4) !== "-" && key.charAt(7) !== "-") {
        let message = "message." + key;
        message = this.$t(message);
        chartObj.labels.push(message);
      } else chartObj.labels.push(key);
      if (data[key] !== null && data[key].length) {
        chartObj.datasets[0].data.push(...data[key]);
      } else {
        chartObj.datasets[0].data.push(data[key]);
      }
    },
    groupTotalsPerDate(objArr) {
      const temp = {};

      for (let i = 0; i < objArr.length; i++) {
        if (!temp[objArr[i].date]) {
          temp[objArr[i].date] = objArr[i].total;
        } else {
          temp[objArr[i].date] += objArr[i].total;
        }
      }
      return temp;
    },
    parseDataForComparision(data, label1, label2, color1, color2) {
      const chartData = {
        labels: [],
        datasets: [
          {
            barThickness: 12,
            label: label1,
            backgroundColor: color1,
            data: [],
          },
          {
            barThickness: 12,
            label: label2,
            backgroundColor: color2,
            data: [],
          },
        ],
      };

      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          chartData.labels.push(key);
          chartData.datasets[0].data.push(data[key].actual);
          chartData.datasets[1].data.push(data[key].budget);
        }
      }

      return chartData;
    },
    getAllDatesForComparison(costs, budget) {
      let costsObj = {};
      for (let key in costs) {
        if (costs.hasOwnProperty(key)) {
          costsObj[key] = { actual: costs[key] };
        }
      }

      let budgetObj = {};
      for (let key in budget) {
        if (budget.hasOwnProperty(key)) {
          budgetObj[key] = { budget: budget[key] };
        }
      }

      let costsLength = Object.keys(costsObj).length;
      let budgetLength = Object.keys(budgetObj).length;
      let total = null;

      if (costsLength > budgetLength) {
        for (let key in costsObj) {
          if (!costsObj[key]["budget"]) {
            costsObj[key]["budget"] = 0;
          }
        }

        for (let key in budgetObj) {
          if (typeof costsObj[key] === "undefined") {
            costsObj[key] = { actual: 0, budget: 0 };
          }
          costsObj[key]["budget"] = budgetObj[key]["budget"];
        }

        total = costsObj;
      } else if (costsLength < budgetLength) {
        for (let key in costsObj) {
          budgetObj[key]["actual"] = costsObj[key]["actual"];
        }
        for (let key in budgetObj) {
          if (!budgetObj[key]["actual"]) {
            budgetObj[key]["actual"] = 0;
          }
        }
        total = budgetObj;
      } else {
        for (let key in budgetObj) {
          costsObj[key]["budget"] = budgetObj[key]["budget"];
        }
        total = costsObj;
      }

      return total;
    },
  },
};
</script>

<style>
#line-chart {
  height: 250px;
}

#horizontalbar-chart {
  height: 250px;
}

#bar-chart {
  height: 250px;
}
</style>
